import React, { FC } from 'react'
import Loader from '../../../components/common/Loader'
import { CheckCircle, Error, ErrorOutline, InfoOutlined } from '@mui/icons-material'
import { Tooltip } from '../../../components/ui'
import { processingStatuses } from '../../../lib/utils/formatDocument'

interface ProcessingStatusIconProps {
	status: number
	size?: number
	isEmptyFile?: boolean
	objectType?: number
	withTooltip?: boolean
}

const ProcessingStatusIcon: FC<ProcessingStatusIconProps> = ({
	status,
	size = 18,
	isEmptyFile,
	objectType,
	withTooltip = true,
}) => {
	let icon = null

	if (objectType === 1) {
		icon = <InfoOutlined style={{ width: size, height: size }} />
	} else if (isEmptyFile) {
		icon = <ErrorOutline
			className="fill-stroke-dark"
			style={{ width: size, height: size }}
		/>
	} else {
		switch (status) {
			case 0:
			case 2:
				icon = <Loader size={size - 2} />
				break
			case 1:
				icon = <CheckCircle
					className="fill-positive"
					style={{ width: size, height: size }}
				/>
				break
			case 3:
				icon = <Error
					className="fill-negative"
					style={{ width: size, height: size }}
				/>
				break
			default:
				icon = null
		}
	}

	return icon ? withTooltip ? (
		<Tooltip
			label={objectType ? "Folder can't have a status" : isEmptyFile ? "File doesn't have any content" : (status in processingStatuses ? processingStatuses[status] : '')}
			className="w-[100px] justify-center"
			classNameChildrenWrapper="w-fit"
		>
			{icon}
		</Tooltip>
	) : icon : '-'
}

export default ProcessingStatusIcon
